<template>
  <tr class="grid grid-cols-2 grid-flow-row md:table-row">
    <td
      class="md:hidden px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
    >
      Customer
    </td>
    <td
      class="px-1 md:px-3 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 font-medium text-gray-900"
    >
      {{ checkout.customer.firstName }} {{ checkout.customer.lastName }}
    </td>
    <td
      class="md:hidden px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
    >
      Created at
    </td>
    <td
      class="px-1 md:px-3 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 text-gray-500"
    >
      {{ checkout.createdDate | dateFilter }}
    </td>
    <td
      class="md:hidden px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
    >
      Recovery status
    </td>
    <td
      class="px-1 md:px-3 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 text-gray-500"
    >
      <span
        class="px-2 inline-flex text-xs leading-5 font-normal rounded-full "
        :class="{
          'bg-red-100 text-red-800': !checkout.isRecovered,
          'bg-green-100 text-green-800': checkout.isRecovered
        }"
      >
        {{ checkout.isRecovered ? "recovered" : "Not recovered" }}
      </span>
    </td>
    <td
      class="md:hidden px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
    >
      Message status
    </td>
    <td
      class="px-1 md:px-3 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 text-gray-500"
    >
      <span
        class="px-2 inline-flex text-xs leading-5 font-normal rounded-full "
        :class="{
          'bg-red-100 text-red-800': !checkout.isMessageSent,
          'bg-green-100 text-green-800': checkout.isMessageSent
        }"
      >
        {{ checkout.isMessageSent ? "Sent" : "Not sent" }}
      </span>
    </td>
    <td
      class="md:hidden px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
    >
      Checkout Id
    </td>
    <td
      class="px-1 md:px-3 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 font-medium text-gray-900"
    >
      {{ checkout.checkoutId }}
    </td>
    <td
      class="md:hidden px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
    >
      Total
    </td>

    <td
      class="px-1 md:px-3 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 font-medium text-gray-900"
    >
      <span>{{ checkout.currency }} {{ checkout.totalPrice }}</span>
      <br />
      <span
        class="text-gray-500"
        v-if="checkout.customerMeta && checkout.customerMeta.lastOrderTime"
        >{{ checkout.customerMeta.lastOrderTime | dateFilter }}</span
      >
    </td>
    <td
      class="md:hidden px-3 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
    ></td>
    <td
      class="px-1 md:px-3 py-2 md:py-4 whitespace-no-wrap border-b border-gray-200 text-xs leading-5 font-medium text-gray-900"
    >
      <div class="mt-2">
        <span
          v-if="checkout.customerMeta && checkout.customerMeta.shouldNotDisturb"
          class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium leading-4 bg-indigo-100 text-indigo-800"
        >
          Do not disturb
          <button
            type="button"
            class="flex-shrink-0 ml-1.5 inline-flex text-indigo-500 focus:outline-none focus:text-indigo-700"
            aria-label="Remove small badge"
            @click="removeTag('shouldNotDisturb')"
          >
            <svg
              class="h-2 w-2"
              stroke="currentColor"
              fill="none"
              viewBox="0 0 8 8"
            >
              <path
                stroke-linecap="round"
                stroke-width="1.5"
                d="M1 1l6 6m0-6L1 7"
              />
            </svg>
          </button>
        </span>
        <span
          v-if="checkout.customerMeta && checkout.customerMeta.isNotOnWhatsapp"
          class="inline-flex mx-1 items-center px-2.5 py-0.5 rounded-full text-xs font-medium leading-4 bg-indigo-100 text-indigo-800"
        >
          Not on Whatsapp
          <button
            type="button"
            class="flex-shrink-0 ml-1.5 inline-flex text-indigo-500 focus:outline-none focus:text-indigo-700"
            aria-label="Remove small badge"
            @click="removeTag('isNotOnWhatsapp')"
          >
            <svg
              class="h-2 w-2"
              stroke="currentColor"
              fill="none"
              viewBox="0 0 8 8"
            >
              <path
                stroke-linecap="round"
                stroke-width="1.5"
                d="M1 1l6 6m0-6L1 7"
              />
            </svg>
          </button>
        </span>
      </div>

      <div class="mt-2">
        <AddTagDropdown @onItemClicked="addTag" />
      </div>
    </td>
    <td
      class="px-1 md:px-3 py-2 md:py-4 whitespace-no-wrap text-right border-b border-gray-200 text-xs leading-5 font-medium"
    >
      <SendMessageDropdown :checkout="checkout" />
    </td>
  </tr>
</template>

<script>
import SendMessageDropdown from "./SendMessageDropdown";
import AddTagDropdown from "./AddTagDropdown";

import { format } from "date-fns";

export default {
  name: "CartListItem",
  components: {
    SendMessageDropdown,
    AddTagDropdown
  },
  props: {
    checkout: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  filters: {
    dateFilter(value) {
      return format(new Date(value * 1000), "h:mm a, MMM dd");
    }
  },
  methods: {
    addTag(tag) {
      const obj = {};
      obj[tag] = true;
      this.$store.dispatch("updateTag", {
        requestParams: obj,
        checkoutId: this.checkout.id
      });
      this.$emit("refreshCurrentPage");
    },
    removeTag(tag) {
      const obj = {};
      obj[tag] = false;
      this.$store.dispatch("updateTag", {
        requestParams: obj,
        checkoutId: this.checkout.id
      });
      this.$emit("refreshCurrentPage");
    }
  }
};
</script>

<style lang="scss" scoped></style>
